document.addEventListener("DOMContentLoaded", () => {
  // Shared wishlist storage (localStorage key: "wishlist")
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem("wishlist")) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
    document.dispatchEvent(new CustomEvent("wishlist:updated"));
  }

  // Header count badge (global; injected into the existing wishlist icon).
  // Matches the Dawn cart count bubble: white disc, dark text, top-right of icon.
  function injectBadgeStyles() {
    if (document.getElementById("wishlist-badge-styles")) return;
    const style = document.createElement("style");
    style.id = "wishlist-badge-styles";
    style.textContent =
      ".header__icon--wishlist{position:relative;overflow:visible}" +
      ".header__icon--wishlist .wishlist-count-bubble{position:absolute;top:.2rem;right:.2rem;z-index:5;" +
      "display:flex;align-items:center;justify-content:center;box-sizing:border-box;" +
      "min-width:1.7rem;height:1.7rem;padding:0 .4rem;border-radius:1.7rem;" +
      "background-color:rgb(var(--color-button));color:rgb(var(--color-button-text));" +
      "font-size:.9rem;font-weight:600;line-height:1;letter-spacing:.02rem}" +
      ".header__icon--wishlist .wishlist-count-bubble[hidden]{display:none}";
    document.head.appendChild(style);
  }

  function getBadge() {
    const icon = document.querySelector(".header__icon--wishlist");
    if (!icon) return null;
    injectBadgeStyles();
    let badge = icon.querySelector("[data-wishlist-count]");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "wishlist-count-bubble";
      badge.setAttribute("data-wishlist-count", "");
      badge.setAttribute("aria-hidden", "true");
      badge.hidden = true;
      icon.appendChild(badge);
    }
    return badge;
  }

  function updateBadge() {
    const badge = getBadge();
    if (!badge) return;
    const count = getWishlist().length;
    if (count > 0) {
      badge.textContent = count > 99 ? "99+" : String(count);
      badge.hidden = false;
    } else {
      badge.textContent = "";
      badge.hidden = true;
    }
  }

  updateBadge();
  document.addEventListener("wishlist:updated", updateBadge);
  window.addEventListener("storage", (e) => {
    if (e.key === "wishlist") updateBadge();
  });
  document.addEventListener("shopify:section:load", updateBadge);

  // Product-page wishlist button (unchanged behaviour, only where present)
  const wishlistBtn = document.getElementById("wishlistBtn");
  if (!wishlistBtn) return;

  function getVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function getHandle() {
    const parts = window.location.pathname.split("/products/");
    return parts[1] ? parts[1].split("?")[0] : null;
  }

  function isInWishlist(variantId) {
    return getWishlist().some((item) => item.variantId == variantId);
  }

  function updateWishlistUI(announce) {
    const variantId = getVariantId();
    if (!variantId) return;
    const added = isInWishlist(variantId);
    const label = wishlistBtn.querySelector(".wishlist-btn__label");
    const icon = wishlistBtn.querySelector(".wishlist-btn__icon");
    const addText = wishlistBtn.dataset.labelAdd || "Add to wishlist";
    const addedText = wishlistBtn.dataset.labelAdded || "Added to wishlist";

    wishlistBtn.classList.toggle("added", added);
    wishlistBtn.setAttribute("aria-pressed", added ? "true" : "false");
    if (label) {
      // Product-page markup: keep the heart icon, swap only the label.
      label.textContent = added ? addedText : addText;
      if (icon) icon.textContent = added ? "\u2665" : "\u2661";
    } else {
      wishlistBtn.textContent = added ? addedText : addText;
    }

    if (announce) {
      const status = document.getElementById(wishlistBtn.dataset.statusTarget || "");
      if (status) {
        status.textContent = added
          ? wishlistBtn.dataset.statusAdded || "Added to your wishlist."
          : wishlistBtn.dataset.statusRemoved || "Removed from your wishlist.";
      }
    }
  }

  wishlistBtn.addEventListener("click", () => {
    const variantId = getVariantId();
    const handle = getHandle();
    if (!variantId || !handle) return;
    let wishlist = getWishlist();
    if (isInWishlist(variantId)) {
      wishlist = wishlist.filter((item) => item.variantId != variantId);
    } else {
      wishlist.push({ variantId: variantId, handle: handle });
    }
    saveWishlist(wishlist);
    updateWishlistUI(true);
  });

  document.addEventListener("change", (e) => {
    if (e.target.closest(".product-form, variant-selects")) {
      updateWishlistUI(false);
    }
  });

  // Dawn variant picker updates the variant id after re-rendering; follow it.
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, () => updateWishlistUI(false));
  }

  updateWishlistUI(false);
});
